import styled from 'styled-components';
import breakpoints from 'theme/atoms/breakpoints';
import * as Text from 'theme/components/Text.style';

export const EmailValue = styled(Text.P2)`
  overflow-wrap: anywhere;
`;

export const EditBlock = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const EditControls = styled('div')`
  align-items: center;
  display: flex;
  gap: 10px;
  width: 100%;

  @media (max-width: ${breakpoints.tablet}) {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const EditFieldGrow = styled('div')`
  flex: 1;
  min-width: 220px;

  @media (max-width: ${breakpoints.tablet}) {
    min-width: 0;
    width: 100%;
  }
`;

export const EditButtonsRow = styled('div')`
  align-items: center;
  display: flex;
  gap: 10px;

  @media (max-width: ${breakpoints.tablet}) {
    width: 100%;

    > button {
      flex: 1;
      width: 100%;
    }
  }
`;
